import { PUBLIC_APP_ENV } from '$app/env/public';

export const isOnDev = () => {
	return (
		!PUBLIC_APP_ENV ||
		PUBLIC_APP_ENV === 'local' ||
		PUBLIC_APP_ENV === 'dev' ||
		PUBLIC_APP_ENV === 'dev-preview'
	);
};
